import React, { FormEvent } from 'react';
import { Container, Row, Col, Button, Form, Alert } from 'react-bootstrap';
import { useParams } from 'react-router-dom';

import { useDetailsEventTypeQuery, useUpdateEventTypeMutation } from './eventTypesApi';
import Loading from '../../app/components/Loading';
import { RequireTier } from '../auth/RequireTier';

function EventTypeDetails() {
  const params = useParams<{ eventTypeId: string }>();
  const [name, setName] = React.useState<string>('');
  const [description, setDescription] = React.useState<string>('');
  const [messageTemplate, setMessageTemplate] = React.useState<string>('');

  const { data: eventType, isError, isFetching } = useDetailsEventTypeQuery(params.eventTypeId || '');
  const [updateEventType, { isLoading: isUpdating, isError: updatingError, isSuccess: updatingSuccess }] =
    useUpdateEventTypeMutation();

  React.useEffect(() => {
    if (eventType) {
      setName(eventType.name || '');
      setDescription(eventType.description || '');
      setMessageTemplate(eventType.messageTemplate || '');
    }
  }, [eventType]);

  const onSubmit = (event: FormEvent) => {
    event.preventDefault();

    if (!eventType) return;
    updateEventType({ id: eventType?.id, name, description, messageTemplate });
  };

  if (isFetching) {
    return <Loading text="Loading event type" />;
  }

  if (isError || !eventType) {
    return <Alert variant="danger">An error occured while fetching the event type</Alert>;
  }

  return (
    <main>
      <h1 className="mb-4">Event type details</h1>
      {isUpdating && <Alert variant="info">Updating event type...</Alert>}
      {updatingError && <Alert variant="danger">An error occured while updating the event type</Alert>}
      {updatingSuccess && <Alert variant="success">Updated successfully</Alert>}

      <Container>
        <Form onSubmit={onSubmit}>
          <Row className="mb-4">
            <Col xs={2}>
              <strong>ID</strong>
            </Col>
            <Col xs={10}>
              <span>{eventType.id}</span>
            </Col>
          </Row>
          <Row className="mb-4">
            <Col xs={2}>
              <strong>Display name</strong>
            </Col>
            <Col xs={10}>
              <Form.Control required type="text" value={name} onChange={(event) => setName(event.target.value)} />
            </Col>
          </Row>
          <Row className="mb-4">
            <Col xs={2}>
              <strong>Description</strong>
            </Col>
            <Col xs={10}>
              <Form.Control
                required
                type="text"
                as="textarea"
                rows={4}
                value={description}
                onChange={(event) => setDescription(event.target.value)}
              />
            </Col>
          </Row>
          <Row className="mb-4">
            <Col xs={2}>
              <strong>Message template</strong>
            </Col>
            <Col xs={10}>
              <Form.Control
                required
                type="text"
                as="textarea"
                rows={2}
                value={messageTemplate}
                onChange={(event) => setMessageTemplate(event.target.value)}
              />
            </Col>
          </Row>
          <Row className="mb-4">
            <Col xs={{ offset: 10, span: 2 }}>
              <RequireTier requiredTier="admin" policy="disable">
                <Button type="submit" variant="success" disabled={isUpdating}>
                  Save
                </Button>
              </RequireTier>
            </Col>
          </Row>
        </Form>
      </Container>
    </main>
  );
}

export default EventTypeDetails;
